import styled from '@emotion/styled'
import { calcRem } from '../../../../../__styling'

export const StyledRaceSwingContainer = styled('div')({
    display: 'block',
    position: 'relative',
})

export const RaceSwingPercentContainer = styled('div')({
    position: 'absolute',
    width: '100%',
    bottom: calcRem(-2),
    fontSize: calcRem(12),
    lineHeight: calcRem(12),
    fontWeight: 600,
    textAlign: 'center',
})
